var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'seller-add'},"title":((_vm.$t('menuitems.seller.text')) + " (" + (_vm.$t('menuitems.seller.agency')) + ")")}}),_c('List',{attrs:{"dataList":_vm.sellerDataList,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'suspend', color: true}],"fields":[("code: " + (_vm.$t('seller.code'))), ("type: " + (_vm.$t('seller.type'))), ("name: " + (_vm.$t('seller.name'))), 
          ("phone_no_1: " + (_vm.$t('seller.phone-no'))), ("email: " + (_vm.$t('seller.email'))), ("address: " + (_vm.$t('seller.address'))), ("suspend: " + (_vm.$t('general.status')))],"deletes":[_vm.deleted, null],"edit":{link: 'seller-edit'},"view":{link: 'seller-view'},"more":{
          sub: [{
            name: 'setting.security.user.suspend', icon: 'bx bx-no-entry', action: 'suspend', column: 'id', show: {column: 'user_suspend_id', value: 1}
          },{
            name: 'setting.security.user.unsuspend', icon: 'bx bx-check-circle', action: 'unsuspend', column: 'id', show: {column: 'user_suspend_id', value: 2}
          }] 
        },"filter":{
          search: ['sellers.code', 'sellers.name', 'sellers.name_en', 'sellers.phone_no_1', 'sellers.phone_no_2'],
          dropdown: [{
            title: 'seller.type',
            field: 'sellers.type_id',
            data: this.typeDataList.data,
            width: 2,
            default: 2
          }]
        }},on:{"more":_vm.moreClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }